module.exports = __webpack_public_path__ + "static/media/banner.73394530.jpeg";